const getDefaultState = () => {
    return {
        activeLanguages: ['eng', 'nob'],
        stringGroupSearchTerm: '',
        stringGroupTags: [],
        stringSearchTerm: '',
        translationJobSearchTerm: '',
    }
}

const state = getDefaultState()

const getters = {
    activeLanguages(state: any) {
        return state.activeLanguages
    },

    stringGroupSearchTerm(state: any) {
        return state.stringGroupSearchTerm
    },

    stringGroupTags(state: any) {
        return state.stringGroupTags
    },

    stringSearchTerm(state: any) {
        return state.stringSearchTerm
    },

    translationJobSearchTerm(state: any) {
        return state.translationJobSearchTerm
    },
}

const mutations = {
    activeLanguages(state: any, payload: any) {
        state.activeLanguages = payload
    },

    stringGroupSearchTerm(state: any, payload: any) {
        state.stringGroupSearchTerm = payload
    },

    stringGroupTags(state: any, payload: any) {
        state.stringGroupTags = payload
    },

    stringSearchTerm(state: any, payload: any) {
        state.stringSearchTerm = payload
    },

    translationJobSearchTerm(state: any, payload: any) {
        state.translationJobSearchTerm = payload
    },

    //RESET
    resetLanguageUserSettings(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
